<template>
  <div
    class="container-background"
    :style="{ 'background-color': lightMode ? '#62A0F0' : '#021F23' }"
  >
    <div class="background-landscape" :class="{ 'light-mode': lightMode,'dark-mode': !lightMode }"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Background",

  computed: {
    ...mapState(["lightMode"])
  }
};
</script>
<style>
.container-background {
  position: fixed;
  height: 100vh;
  width: 100vw;
}
.background-landscape {
  filter: blur(6px);
  background-repeat: repeat;
  background-size: cover;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  /* animation-name: horizontalAnimation; */
  animation-duration: 1000s;
  height: 100%;
  transition: all 0.5s;
  transform: scale(1.1);
}
.dark-mode {
  background-image: url("/img/dark.jpg");
}
.light-mode {
  background-image: url("/img/light.jpg");
}
/* @keyframes horizontalAnimation {
  from {
    background-position: 0px 0px;
  }
  to {
    background-position: -50000px 0px;
  }
} */
</style>
